/**
 * The two copies of a supplier's NDA: the one the supplier signed and uploaded
 * with their application, and the one Betika countersigned, which Legal
 * uploads afterwards. They are separate documents so the supplier's original
 * stays on file.
 */

export const COUNTERSIGNED_NDA = 'nda_countersigned';

// Legal signs on Betika's side. The server enforces the same list.
const COUNTERSIGN_ROLES = ['legal', 'super_admin'];

export const canUploadCountersignedNda = (user, supplier) =>
  COUNTERSIGN_ROLES.includes(user?.role) && !!supplier && supplier.status !== 'draft';

export const countersignedNdaOf = (supplier) =>
  (Array.isArray(supplier?.documents) ? supplier.documents : [])
    .find((doc) => doc.documentType === COUNTERSIGNED_NDA) || null;

export const uploaderName = (doc) => {
  const by = doc?.uploadedBy;
  if (!by || typeof by !== 'object') return '';
  return [by.firstName, by.lastName].filter(Boolean).join(' ');
};

export const isPdf = (file) => /\.pdf$/i.test(file?.name || '');
